import React from 'react';
import { HeroUIProvider as BaseHeroUIProvider } from '@heroui/react';

interface HeroUIProviderProps {
  children: React.ReactNode;
}

export const HeroUIProvider: React.FC<HeroUIProviderProps> = ({ children }) => {
  return <BaseHeroUIProvider>{children}</BaseHeroUIProvider>;
};

export default HeroUIProvider;
